<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div
    *ngIf="
      staffEventBusinessPersonAudits && staffEventBusinessPersonAudits.length > 0;
      else noAudits
    "
  >
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="staffEventBusinessPersonAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Staff Event Business Person audits </ng-template>
</ng-template>
